import { Component, OnInit } from '@angular/core';
import { NacoService } from '../../domains/services/naco.service';

@Component({
    selector: 'naker-auth-silent',
    template: 'Please wait...',
})
export class AuthSilentPage implements OnInit {
    public constructor(private naco: NacoService) {}

    public ngOnInit(): void {
        const timeout = setTimeout(() => {
            clearTimeout(timeout);
            this.naco.redirect('/');
        }, 2000);
    }
}
